export const isTemporarySlug = url => url.includes('-temporary-slug-');
export const stripProtocol = url => url.replace(/^(http:\/\/)|(https:\/\/)/, '');